import Header from 'components/header';

import info from 'assets/images/info.svg';
import warning from 'assets/images/warning.svg';
import clock from 'assets/images/clock-afternoon.svg';
import styles from './styles.module.scss';

type BottomSheetResultProps = {
  type: 'info' | 'clock' | 'warning';
  header: string;
  children?: React.ReactNode;
};

const map = {
  info,
  warning,
  clock,
} as const;

const BottomSheetResult: React.FC<BottomSheetResultProps> = (props) => {
  const { type, header, children } = props;

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <img alt='Значок' src={map[type]} width={60} height={60} />
        <Header className={styles.header} text={header} />
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
};

export default BottomSheetResult;
